import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import OrderPage from "@/pages/OrderPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Orders from "@/pages/admin/Orders";
import Organizations from "@/pages/admin/Organizations";
import OrgTracker from "@/pages/admin/OrgTracker";
import OrgLinks from "@/pages/admin/OrgLinks";
import OrgStatus from "@/pages/OrgStatus";
import ReportAccess from "@/pages/ReportAccess";
import DowDisclosures from "@/pages/DowDisclosures";
import StatusLookup from "@/pages/StatusLookup";
import Reissue from "@/pages/Reissue";
import ProvideInfo from "@/pages/ProvideInfo";
import SignAuthorization from "@/pages/SignAuthorization";
import OrderFinish from "@/pages/OrderFinish";
import Account from "@/pages/admin/Account";
import DowIntegration from "@/pages/admin/DowIntegration";
import Codes from "@/pages/admin/Codes";
import Cases from "@/pages/admin/Cases";
import CaseDetail from "@/pages/admin/CaseDetail";
import Alerts from "@/pages/admin/Alerts";
import AuditLog from "@/pages/admin/AuditLog";
import Settings from "@/pages/admin/Settings";
import Billing from "@/pages/admin/Billing";
import ManualCase from "@/pages/admin/ManualCase";
import EditCase from "@/pages/admin/EditCase";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/:slug" element={<Apply />} />
          <Route path="/status/:token" element={<OrgStatus />} />
          <Route path="/report/:token" element={<ReportAccess />} />
          <Route path="/dow-disclosures" element={<DowDisclosures />} />
          <Route path="/check-status" element={<StatusLookup />} />
          <Route path="/reissue/:token" element={<Reissue />} />
          <Route path="/provide/:token" element={<ProvideInfo />} />
          <Route path="/sign-authorization/:token" element={<SignAuthorization />} />
          <Route path="/order/finish/:token" element={<OrderFinish />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Overview />} />
            <Route path="orders" element={<Orders />} />
            <Route path="organizations" element={<Organizations />} />
            <Route path="organizations/:id" element={<OrgTracker />} />
            <Route path="links" element={<OrgLinks />} />
            <Route path="codes" element={<Codes />} />
            <Route path="cases" element={<Cases />} />
            <Route path="cases/new" element={<ManualCase />} />
            <Route path="cases/:id" element={<CaseDetail />} />
            <Route path="cases/:id/edit" element={<EditCase />} />
            <Route path="billing" element={<Billing />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="settings" element={<Settings />} />
            <Route path="account" element={<Account />} />
            <Route path="dow" element={<DowIntegration />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
